import { render, staticRenderFns } from "./GrantInfo.vue?vue&type=template&id=612b618b&"
import script from "./GrantInfo.vue?vue&type=script&lang=js&"
export * from "./GrantInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports